import { __rest } from '../../../_virtual/_tslib.js';
import { isBigInt, bigIntToHex } from '@dynamic-labs/utils';

const convertTransactionValuesFromBigIntToHex = (_a) => {
    var { gasPrice } = _a, transaction = __rest(_a, ["gasPrice"]);
    return (Object.assign(Object.assign({}, transaction), { gasPrice: isBigInt(gasPrice) ? bigIntToHex(gasPrice) : gasPrice }));
};

export { convertTransactionValuesFromBigIntToHex };
